import React, { useState, useEffect } from 'react';
import { Loader } from '../../core/components';
import ConfigurationService from '../../core/services/ConfigurationService';
import RouteParamsService from '../../core/services/RouteParamsService';
import UserManagerService from '../../core/services/UserManagerService';

const LoginRoute = () => {
  const [isLoading, setIsLoading] = useState(true);

  const configurationService = new ConfigurationService();

  const redirect = async () => {
    const identityServerUrl = await configurationService.getIdentityServerUrl()
    const returnUrl = await configurationService.getWebsiteUrl();
    const queryString = RouteParamsService.getQueryParameters();

    const usr = await UserManagerService.getUser();

    if (!usr?.expired) {
      window.location.href = returnUrl;
      setIsLoading(false);
      return;
    }

    let providerId;

    Object.keys(queryString).forEach(key => {
      if (key.toLocaleLowerCase() === 'providerid') {
        providerId = queryString[key] as string;
      }
    });

    if (!!providerId) {
      window.location.href = `${identityServerUrl}/account/loginExternal?providerId=${providerId}&returnUrl=${encodeURIComponent(returnUrl)}`;
    } else {
      window.location.href = returnUrl
    }

    setIsLoading(false);
  }

  useEffect(() => {
    redirect();
    // eslint-disable-next-line
  }, []);

  return isLoading ? <Loader opacity={1} /> : <> OK </>
};

export default LoginRoute
